<template>
  <div v-if="hasContent" class="security-footer-container">
    <div class="security-footer-inner">
      <div class="security-footer-copy">
        <div v-if="paymentOptions?.title?.value" class="security-footer-title">
          <span class="security-footer-icon bg-shield-icon"></span>
          <RichText :field="paymentOptions.title" />
        </div>
        <div v-if="paymentOptions?.body?.value" class="security-footer-body">
          <RichText :field="paymentOptions.body" />
        </div>
      </div>

      <div v-if="paymentOptions?.options?.length">
        <ul class="security-footer-icons" aria-label="Accepted payment options">
          <li v-for="option in paymentOptions.options" :key="option.type">
            <img :src="option.src" :alt="option.label" :class="option.className" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import { IPaymentSecurityFooterOptions } from '@/interfaces/forms/payment-security-footer.interface';

const props = defineProps<{
  paymentOptions?: IPaymentSecurityFooterOptions | null;
}>();

const hasContent = computed(() =>
  Boolean(
    props.paymentOptions?.title?.value || props.paymentOptions?.body?.value || props.paymentOptions?.options?.length
  )
);
</script>
